import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import { attachmentPath } from "../../lib/apiPaths";
import {
  AttachmentHoverPreview,
  attachmentActionIcon,
} from "../AttachmentHoverPreview";
import { AttachmentLabel, attachmentFileIcon } from "../AttachmentPreviews";
import { Icon } from "../Icon";
import { Text } from "../Text";

export function UserMessageAttachments({
  attachments,
}: {
  attachments: ChatEntryWithSubTables["attachments"];
}) {
  return attachments.map((att) => (
    <AttachmentHoverPreview
      key={att.id}
      fileName={att.fileName}
      mediaType={att.mediaType}
      sizeBytes={att.sizeBytes}
      url={attachmentPath(att.id)}
    >
      <AttachmentLabel type="button">
        <span className="file-icon">
          <Icon name={attachmentFileIcon(att.mediaType)} size={10} />
        </span>
        <span className="download-icon">
          <Icon name={attachmentActionIcon(att.mediaType)} size={10} />
        </span>
        <Text variant="text-small-md" ellipsis>
          {att.fileName}
        </Text>
      </AttachmentLabel>
    </AttachmentHoverPreview>
  ));
}
